import React from 'react';
import { Badge, Card } from '@/components/ui';
import { formatCurrency } from '@/utils/format';
import type { ConstructionBoqItem } from '../types/construction-boq.types';
import { AuthButton } from '@/core/permissions/AuthButton';

interface BoqItemMobileListProps {
  items: ConstructionBoqItem[];
  onEdit: (item: ConstructionBoqItem) => void;
  onDelete: (id: string) => void;
}

export function BoqItemMobileList({ items, onEdit, onDelete }: BoqItemMobileListProps) {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <Card key={item.id} className="p-4 border-slate-100">
          <div className="flex justify-between items-start mb-3">
            <div className="flex flex-col">
              <span className="text-[10px] font-mono text-slate-400  tracking-tighter">{item.item_code}</span>
              <h4 className="font-bold text-slate-800 text-sm">{item.item_name}</h4>
            </div>
            <div className="flex gap-1">
              <AuthButton
                module="boq"
                action="update"
                variant="ghost"
                size="sm"
                icon="ri-edit-line"
                onClick={() => onEdit(item)}
              />
              <AuthButton
                module="boq"
                action="delete"
                variant="ghost"
                size="sm"
                icon="ri-delete-bin-line"
                className="text-red-500"
                onClick={() => onDelete(item.id)}
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 py-3 border-y border-slate-50">
            <div>
              <p className="text-[8px] text-slate-400 font-bold  tracking-widest mb-0.5">Số lượng</p>
              <p className="text-xs font-bold text-slate-700">{item.quantity} {item.unit}</p>
            </div>
            <div className="col-span-2 text-right">
              <p className="text-[8px] text-slate-400 font-bold  tracking-widest mb-0.5">Thành tiền</p>
              <p className="text-sm font-black text-os-primary">{formatCurrency(item.total_amount)}</p>
            </div>
          </div>

          <div className="pt-2 flex justify-between items-center">
            <span className="text-[10px] text-slate-400">Đơn giá: {formatCurrency(item.unit_price)}</span>
            <Badge variant="default" className="text-[8px] font-bold ">{(item as any).status_code || 'Planned'}</Badge>
          </div>
        </Card>
      ))}

      {items.length === 0 && (
        <div className="py-12 text-center text-slate-400 italic text-sm">
          Chưa có hạng mục nào.
        </div>
      )}
    </div>
  );
}
